import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'
import { ChevronIcon } from '@sainsburys-tech/bolt-icons'
import { defaultImgParams } from '../../../helpers/ComponentHelper'

export const OffersScroll = styled(Row)`
  text-decoration: none;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
`

export const PaddedRow = styled(Row)`
  padding-right: 0;
  margin-right: 15px;
`

export const NavCardContainer = styled(Column)`
  ${(props) =>
    css`
      border: ${props.theme.size.border.width.sm} solid ${props.theme.color.monochrome.light};
      border-radius: ${props.theme.size.border.radius.lg};
      margin-bottom: ${props.theme.size.spacing.lg};

      @media (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        min-height: ${props.image ? '80px' : '50px'};
      }
    `}
  cursor: pointer;
  text-decoration: none;
  min-height: ${(props) => (props.image ? '80px' : '50px')};
  display: flex;
  justify-content: space-between;
`

export const NavLink = styled.p`
  ${(props) =>
    css`
      color: ${props.theme.color.monochrome.darker};
      padding: ${props.theme.size.spacing.lg};
      ${!props.image && 'margin-bottom: 0 !important'};
    `}
  text-align: left;
  ${(props) =>
    props.image &&
    css`
      flex-basis: 66.66666%;
      max-width: 66.66666%;
    `}
`

export const NavLinkLastWord = styled.span`
  display: inline-block;
`

export const Chevron = styled(ChevronIcon)`
  ${(props) =>
    css`
      margin-left: ${props.theme.size.spacing.md};
      stroke: ${props.theme.color.palette['brand-1-dark']};
    `}
  position: relative;
  top: 2px;
`

export const NavCardImage = styled.div`
  ${(props) =>
    css`
      background-image: url('${props.image}${defaultImgParams}&w=300');
      padding: ${props.theme.size.spacing.sm};
    `}
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
  position: relative;
  background-position: bottom right;
  background-size: contain;
  background-repeat: no-repeat;
  background-origin: content-box;
`
